import { APIS } from "../../components/constants/app.constant";
import { TermsOfService } from "../../components/user-details/models/user-interface";
import { getResource , postResource} from "../axiosService";

export function getTermsOfService(){
    const apiUrl = APIS.TOS;
    return getResource(apiUrl);
}
export function postTermsOfService(data: TermsOfService){
    const apiUrl = APIS.TOS;
    return postResource(apiUrl, data);
}
export function getTOSStatus(){
    const apiUrl = APIS.GET_TOS_STATUS;
    return getResource(apiUrl);
}